module.exports = __webpack_public_path__ + "img/logo_07@2x.7685772a.png";